import { Component, OnInit, Inject, Optional } from '@angular/core';
import { Customer } from '../../../../../../commons/models/customer';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderService } from '../../../../../../commons/services/order.service';
import { Order } from '../../../../../../commons/models/order';

import { AppState } from '../../../../../../store/reducers';
import { Store } from '@ngrx/store';
import * as CustomersActions from '../../../../../../store/actions/customers.actions';
import { User } from '../../../../../../commons/models/user.model';

@Component({
  selector: 'app-new-customer',
  templateUrl: './new-customer.component.html',
  styleUrls: ['./new-customer.component.scss']
})
export class NewCustomerComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();
  customerForm: UntypedFormGroup;

  customers: Customer;
  private _orders: Order[];

  ordersChartData = {
    labels: [],
    datasets: [],
    options: { }
  };

  constructor(
    private store$: Store<AppState>,
    //private customerService: CustomerService,
    private orderService: OrderService,
    private fb: UntypedFormBuilder,
    //public dialog: MatDialog,
    //public dialogRef: MatDialogRef<NewCustomerComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {  }

  ngOnInit() {
    //console.log("Dati ricevuti nel dialog:", this.data);
  
    if (this.data && this.data.user) {
      this.customers = this.data.user;
    }    
  
    this._createForm();
    this.ngOnChanges();
  }
  
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private _createForm() {
    let customerForm = {
      name: ["", Validators.required],
      surname: ["", Validators.required],
      phone: [""],
      email: ["", [Validators.required, Validators.email]],
      fidelityCardPoints: [0],
      active: [false, Validators.required],
      notes: [""],
      defaultTenantId: [""]
    };
  
    this.customerForm = this.fb.group(customerForm);
  }
  

  private ngOnChanges() {
    if (this.customerForm) {
      this.customerForm.reset();
      
      this._initFormValues(this.customers);
    }
  }

  private _initFormValues(customers?: Customer) {
    if (!this.customerForm) return;
  
    if (customers) {
      this.customerForm.patchValue({
        name: customers.name, 
        surname: customers.surname,
        phone: customers.phone,
        email: customers.email,
        fidelityCardPoints: customers.fidelityCardPoints,
        active: customers.active,
        notes: customers.notes,
        defaultTenantId: customers.defaultTenantId
      });
    } else{
      this.customerForm.markAllAsTouched();
    }
  }
  

  private _prepareSaveCustomer(): Customer {
    return Customer.fromFormGroup(this.customerForm, this.customers);
  }

  save() {
    let unsavedEntity = this._prepareSaveCustomer();
    this.store$.dispatch(CustomersActions.saveCustomer({ customer: unsavedEntity }));
  }

  close() {
    if (this.customerForm.dirty) {
          // Se ci sono modifiche, mostra il dialog di conferma
          this.store$.dispatch(CustomersActions.requestCloseCustomersDialog());
        } else {
          // Se il form è pristine (nessuna modifica), chiudi
          this.store$.dispatch(CustomersActions.closeCustomerDialog());
        }  
  }

  revert() {
    this.ngOnChanges();
  }

  deleteCustomer() {
      if (this.customers) {
        this.store$.dispatch(CustomersActions.deleteCustomer({ customer: this.customers.toDTO() }));
      }
    }

  

  // private compileOptions(currency: boolean = false): any {

  //   let options = {
  //     responsive: true,
  //     title: {
  //       fontFamily: 'ProductSansRegular',
  //       fontSize: 20,
  //       position: 'top',
  //       padding: 20,
  //       display: true,
  //       text: `Ordini effettuati dal cliente ${this.customer.name} ${this.customer.surname}`
  //     },
  //     legend: {
  //       display: false
  //     },
  //     tooltips: {
  //       callbacks: {
  //         label: (data) => {
  //           return `Importo: ${data.yLabel.toFixed(2)}€`;
  //         }
  //       }
  //     },
  //     scaleShowValues: true,
  //     scales: {
  //       yAxes: [{
  //         labels: {
  //           display: false
  //         },
  //         gridLines: {
  //           display: false
  //         },
  //         ticks: {
  //           beginAtZero: true,
  //           callback: (amount) => {
  //             return currency ? amount.toFixed(2) + '€' : amount;
  //           }
  //         }
  //       }],
  //       xAxes: [{
  //         gridLines: {
  //           display: false
  //         },
  //         ticks: {
  //           autoSkip: false,
  //           ticks: {
  //             beginAtZero: true
  //           }
  //         }
  //       }]
  //     }
  //   }

  //   return options;
  // }


    /**
     * Getter customer
     * @return {Customer}
     */
	public get customer(): Customer {
		return this.customers;
	}

    /**
     * Setter customer
     * @param {Customer} value
     */
	public set customer(value: Customer) {
    this.customers = value;
    this.ngOnChanges();
  }


    /**
     * Getter orders
     * @return {Order[]}
     */
	public get orders(): Order[] {
		return this._orders;
	}

    /**
     * Setter orders
     * @param {Order[]} value
     */
	public set orders(value: Order[]) {
		this._orders = value;
	}



}
